export default "__VITE_ASSET__D$GMZSLw__"